module.exports = __webpack_public_path__ + "img/HSBC.511af177.png";